module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_27-5545d6d2112c95dc0e5efe9c3571ac17.jpg";